import { MdxDiv } from '@features/mdx/MdxDiv';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';
import { Video } from '@pages/home/dogs/Video';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: '2fd03b9f-0d9e-4f21-9a67-649d1199fb62',
	[LanguageEnum.SK]: '2fd03b9f-0d9e-4f21-9a67-649d1199fb62',
	default: '2fd03b9f-0d9e-4f21-9a67-649d1199fb62'
}


export const Advantages = () => {

	return (
		<MdxDiv className='advantages' articleIds={articleIds} childrenBeforeMd={<Video />}>
		</MdxDiv>
	);
};